import { useLogoutOnMount } from '@/app/_auth/auth-hooks'
import { AuthStepTemplate } from '@/app/_auth/steps/_common/auth-step-template'
import { AuthProviderID } from '@/app/_auth/steps/_common/login-buttons'
import { isVPCMode } from '@/lib/utils'

export function LoginStep() {
  useLogoutOnMount()

  const providers = isVPCMode 
    ? [AuthProviderID.Keycloak]
    : [AuthProviderID.Google, AuthProviderID.Microsoft]

  return (
    <AuthStepTemplate>
      <AuthStepTemplate.Header>
        <AuthStepTemplate.H1 keyName='auth.welcomeTitle' />
        <AuthStepTemplate.H2 keyName='auth.steps.login' />
      </AuthStepTemplate.Header>
      <AuthStepTemplate.LoginButtons providers={providers} />
      <AuthStepTemplate.Footer variant='signUp' />
    </AuthStepTemplate>
  )
}
